<template>
  <v-navigation-drawer
    id="appDrawer"
    v-model="drawer"
    :mini-variant.sync="mini"
    fixed
    :dark="$vuetify.dark"
    app
    width="260"
  >
    <v-toolbar color="primary darken-1" dark>
      <img
        src="@/assets/images/logo-white.png"
        alt="FBASE.Tv"
        width="150"
        style="margin: 0 auto"
      />
    </v-toolbar>
    <vue-perfect-scrollbar
      class="drawer-menu--scroll"
      :settings="scrollSettings"
    >
      <v-list dense expand>
        <template v-for="(item, i) in filteredMenus">
          <!--group with subitems-->
          <v-list-group
            v-if="item.items"
            :key="item.name"
            :group="item.group"
            :prepend-icon="item.icon"
            no-action="no-action"
          >
            <v-list-tile slot="activator" ripple="ripple">
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ $tc('titles.' + item.title) }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <template v-for="(subItem, i) in item.items">
              <!--sub group-->
              <v-list-group
                v-if="subItem.items"
                :key="subItem.name"
                :group="subItem.group"
                sub-group="sub-group"
              >
                <v-list-tile slot="activator" ripple="ripple">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ $tc(subItem.title) }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile
                  v-for="(grand, i) in subItem.children"
                  :key="i"
                  :to="genChildTarget(item, grand)"
                  :href="grand.href"
                  ripple="ripple"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{ $tc(grand.title) }}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list-group>
              <!--child item-->
              <v-list-tile
                v-else
                :key="i"
                :to="genChildTarget(item, subItem)"
                :href="subItem.href"
                :disabled="subItem.disabled"
                :target="subItem.target"
                ripple="ripple"
              >
                <v-list-tile-content>
                  <v-list-tile-title>
                    <span>{{ $tc(subItem.title) }}</span>
                  </v-list-tile-title>
                </v-list-tile-content>
                <!-- <v-circle class="white--text pa-0 circle-pill" v-if="subItem.badge" color="red" disabled="disabled">{{ subItem.badge }}</v-circle> -->
                <v-list-tile-action v-if="subItem.action">
                  <v-icon :class="[subItem.actionClass || 'success--text']">
                    {{ subItem.action }}
                  </v-icon>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list-group>
          <v-subheader
            v-else-if="item.header && menuHasItems(filteredMenus, item.header)"
            :key="i"
          >
            {{ $t('titles.global.' + item.header) }}
          </v-subheader>
          <v-divider
            v-else-if="item.divider && menuHasItems(filteredMenus, item.group)"
            :key="i"
          />
          <!--top-level link-->
          <v-list-tile
            v-else-if="!item.header && !item.divider"
            :key="item.name"
            :to="!item.href ? { name: item.name } : null"
            :href="item.href"
            ripple="ripple"
            :disabled="item.disabled"
            :target="item.target"
            rel="noopener"
          >
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title v-if="item.title">{{
                $tc(`models.${item.title}`, 2)
              }}</v-list-tile-title>
            </v-list-tile-content>
            <v-circle
              v-if="item.badge"
              class="white--text pa-0 chip--x-small"
              :color="item.color || 'primary'"
              disabled="disabled"
            >
              {{ item.badge }}
            </v-circle>
            <v-list-tile-action v-if="item.subAction">
              <v-icon class="success--text">
                {{ item.subAction }}
              </v-icon>
            </v-list-tile-action>
            <v-circle
              v-else-if="item.chip"
              class="caption blue lighten-2 white--text mx-0"
              label="label"
              small="small"
            >
              {{ item.chip }}
            </v-circle>
          </v-list-tile>
        </template>
      </v-list>
      <br />
      <v-divider />
      <v-list v-if="auth._id === '5dac81d3b479505a21d2b316'">
        <v-list-tile
          v-if="
            !(isChangeSeasonActive || isChangeSeasonWorking) && !isCancelled
          "
        >
          <v-btn
            small
            color="primary"
            class="text-uppercase ma-0"
            @click="openModal('active')"
          >
            {{ $t('action.buttons.changeSeason') }}
          </v-btn>
        </v-list-tile>
        <v-list-tile v-else-if="isChangeSeasonActive || isChangeSeasonWorking">
          <v-btn
            :loading="isChangeSeasonWorking"
            :disabled="isChangeSeasonWorking"
            small
            color="error"
            class="text-uppercase ma-0"
            @click="openModal('inactive')"
          >
            {{ $t('action.buttons.cancelChangeSeason') }}
          </v-btn>
        </v-list-tile>
        <v-list-tile v-if="isCancelled">
          <v-btn
            small
            color="primary"
            class="text-uppercase ma-0"
            @click="resetButton"
          >
            {{ $t('action.buttons.resetChangeSeason') }}
          </v-btn>
        </v-list-tile>
        <v-list-tile v-if="lastRevertible">
          <v-btn
            :disabled="
              !lastRevertible &&
              (!isChangeSeasonActive || !isChangeSeasonWorking)
            "
            small
            color="primary"
            class="text-uppercase ma-0"
            @click="openModal('revert-change-season')"
          >
            {{
              $t('action.buttons.revertLastChangeSeason', {
                from: lastRevertibleChangeSeason.nextSeasonStartYear,
                to: lastRevertibleChangeSeason.seasonStartYear,
              })
            }}
          </v-btn>
        </v-list-tile>
        <v-list-tile>
          <v-btn
            v-if="false"
            small
            color="primary"
            class="text-uppercase ma-0"
            @click="openModal('active-test')"
          >
            TEST {{ $t('action.buttons.changeSeason') }}
          </v-btn>
        </v-list-tile>
        <v-list-tile>
          <v-btn
            v-if="true /*isDev*/"
            small
            color="primary"
            class="text-uppercase ma-0"
            @click="openModal('active-direct-change-season')"
          >
            DIRECT CHANGE SEASON
          </v-btn>
        </v-list-tile>
        <v-list-tile v-if="isChangeSeasonActive">
          {{ $t('action.messages.timeRemaining') }} {{ hours }}H:{{
            minutes
          }}m:{{ seconds }}s
        </v-list-tile>
      </v-list>
      <dialog-confirm
        v-model="dialogConfirm"
        :text="dialogText"
        @submit="dialogActions"
      />
    </vue-perfect-scrollbar>
  </v-navigation-drawer>
</template>
<script>
import moment from 'moment'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapState } from 'vuex'
import menu from '../../api/menu'
import DialogConfirm from '@/components/widgets/dialog/DialogConfirm'
import { apiAxios } from '@/helpers'
export default {
  name: 'AppDrawer',
  components: {
    VuePerfectScrollbar,
    DialogConfirm,
  },
  props: {
    expanded: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    isDev: process.env.NODE_ENV == 'development',
    mini: false,
    drawer: true,
    menus: menu,
    scrollSettings: {
      maxScrollbarLength: 160,
    },
    // cancell infos
    isChangeSeasonActive: false,
    isChangeSeasonWorking: false,
    hours: null,
    minutes: null,
    seconds: null,

    // dialog infos
    dialogConfirm: false,
    dialogText: null,

    // choose infos
    isActive: false,
    isCancelled: false,
    revert: false,

    // change season infos
    activeSeasonYear: null,

    // revert change season infos
    lastRevertible: null,
    lastRevertibleChangeSeason: null,
  }),
  computed: {
    ...mapState({
      auth: (state) => state.auth.user,
    }),
    computeGroupActive() {
      return true
    },
    computeLogo() {
      return '/static/m.png'
    },
    filteredMenus() {
      return this.menus.filter((item) => this.hasPermission(item))
    },
    sideToolbarColor() {
      return this.$vuetify.options.extra.sideNav
    },
  },
  created() {
    this.statusChangeSeason()
    window.getApp.$on('APP_DRAWER_TOGGLED', () => {
      this.drawer = !this.drawer
    })
  },

  methods: {
    menuHasItems(menu, groupName) {
      if (groupName)
        return menu
          .filter((elem) => !elem.divider && !elem.header)
          .some((elem) => elem.group == groupName)
      return false
    },
    hasPermission(item) {
      if (item.admin && !this.isAdmin) return false
      let hasPermission = false

      if (!item.admin && !item.requireRole) hasPermission = true
      else if (item.admin && this.isAdmin) hasPermission = true
      else if (item.requireRole && this.can('list', item.title)) {
        hasPermission = true
      }
      return hasPermission
    },
    genChildTarget(item, subItem) {
      if (subItem.href) return
      if (subItem.component) {
        return {
          name: subItem.component,
        }
      }
      return { name: `${item.group}/${subItem.name}` }
    },
    async changeSeason() {
      await this.getLastActiveSeason()
      await apiAxios
        .post('season/change-all', {
          yearStart:
            this.activeSeasonYear ||
            moment().year() - 1 /* , newYearStart: this.activeSeasonYear + 1 */,
        })
        .finally(async () => {
          await this.statusChangeSeason()
        })
    },

    async getLastActiveSeason() {
      let res = await apiAxios.get('/season/getlastactiveseason')
      if (res && res.data) {
        this.activeSeasonYear = res.data.yearStart
      } else {
        this.activeSeasonYear = null
      }
    },

    async lastRevertableSeasonChange() {
      let res = await apiAxios.get('/task/lastseasonchange')
      if (res && res.data) {
        this.lastRevertible = res.data._id
        this.lastRevertibleChangeSeason = res.data
      } else {
        this.lastRevertible = null
        this.lastRevertibleChangeSeason = null
      }
    },
    async revertSeasonChange() {
      await apiAxios
        .post('/task/revertseasonchange', {
          seasonChangeID: this.lastRevertible,
          revertedBy: this.auth._id,
        })
        .finally(async () => {
          await this.statusChangeSeason()
        })
    },
    async testChangeSeason() {
      await apiAxios
        .post('/season/customChangeTest', {
          yearStart: moment().year() - 1,
          changeSeasonConfig: {
            createdByID: this.auth._id,
            immediate: true,
            waitTimeInHours: 0,
          },
        })
        .finally(async () => {
          await this.statusChangeSeason()
        })
    },
    async directChangeSeason() {
      await apiAxios
        .post(
          'season/change-all', // 'task/season-all/changes',
          {
            yearStart: this.activeSeasonYear || moment().year() - 1,
            changeSeasonConfig: {
              createdByID: this.auth._id,
              immediate: true,
              waitTimeInHours: 0,
            },
          }
        )
        .finally(async () => {
          await this.statusChangeSeason()
        })
    },
    async cancelChangeSeason() {
      this.isCancelled = true
      await apiAxios
        .delete('season/cancel-change-all', { userId: this.auth._id })
        .finally(async () => {
          await this.statusChangeSeason()
        })
    },
    async launchExchanger() {
      await apiAxios.get('exchanger/run-sync').then(() => {
        // todo
      })
    },
    async statusChangeSeason(skipIsWorking = false) {
      await this.getLastActiveSeason()
      await this.lastRevertableSeasonChange()

      await apiAxios.get('season/status-change').then((response) => {
        this.isChangeSeasonActive = response.data.active
        this.isChangeSeasonWorking = response.data.working

        if (this.isChangeSeasonActive) {
          const end = moment(moment(response.data.createdAtMS).utc())
            .add(response.data.waitTimeInHours, 'hour')
            .utc()
          let interval = setInterval(async () => {
            const start = moment().utc()
            const diffHours = this.isChangeSeasonActive ? end.diff(start) : -1

            this.hours = Math.floor(
              (diffHours % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
            )
            this.minutes = Math.floor(
              (diffHours % (1000 * 60 * 60)) / (1000 * 60)
            )
            this.seconds = Math.floor((diffHours % (1000 * 60)) / 1000)

            if (diffHours < 0) {
              clearInterval(interval)
              this.hours = '00'
              this.minutes = '00'
              this.seconds = '00'
              if (!skipIsWorking) {
                await this.checkIsWorking()
              }
            }
          }, 1000)
        }
      })
    },
    async checkIsWorking() {
      this.isChangeSeasonWorking = true
      let startedWorking = false
      let endedWorking = false
      let counter = 0
      setTimeout(() => {
        let workingInterval = setInterval(async () => {
          let response = await apiAxios.get('season/status-change')
          if (!startedWorking && response.data.working == true) {
            startedWorking = true
          }

          if (
            startedWorking &&
            !endedWorking &&
            response.data.working == false
          ) {
            endedWorking = true
          }

          if (endedWorking) {
            this.isChangeSeasonWorking = false
            clearInterval(workingInterval)
            await this.statusChangeSeason(true)
          } else if (startedWorking) {
            this.isChangeSeasonWorking = true
          }

          if (counter > 5) {
            this.isChangeSeasonWorking = false
            clearInterval(workingInterval)
            await this.statusChangeSeason(true)
          } else {
            counter++
          }
        }, 60000)
      }, 60000)
    },
    async resetButton() {
      await apiAxios.delete('season/reset-change').finally(async () => {
        await this.statusChangeSeason()
        this.isCancelled = false
      })
    },
    openModal(val) {
      this.dialogConfirm = true
      if (val === 'active') {
        this.revert = false
        this.isActive = true
        this.isActiveTest = false
        this.isDirectTest = false
        this.dialogText = this.$t('action.messages.changeSeasonAlert')
      } else if (val === 'revert-change-season') {
        this.revert = true
        this.dialogText = 'REVERTING SEASON CHANGE'
      } else if (val === 'active-test') {
        this.revert = false
        this.isActive = false
        this.isActiveTest = true
        this.isDirectTest = false
        this.dialogText =
          'TESTING' + this.$t('action.messages.changeSeasonAlert')
      } else if (val === 'active-direct-change-season') {
        this.revert = false
        this.isActive = false
        this.isActiveTest = true
        this.isDirectTest = true
        this.dialogText =
          'DIRECT' + this.$t('action.messages.changeSeasonAlert')
      } else {
        this.revert = false
        this.dialogText = this.$t('action.messages.timeRemainingVal', {
          hour: this.hours,
          minute: this.minutes,
          second: this.seconds,
        })
        this.isActive = false
        this.isActiveTest = false
        this.isDirectTest = false
      }
    },
    dialogActions() {
      if (this.isActive && !this.isActiveTest) {
        this.changeSeason()
      } else if (this.revert) {
        this.revertSeasonChange()
      } else if (!this.isActive && this.isActiveTest && !this.isDirectTest) {
        this.testChangeSeason()
      } else if (!this.isActive && this.isActiveTest && this.isDirectTest) {
        this.directChangeSeason()
      } else {
        this.cancelChangeSeason()
      }
    },
  },
}
</script>

<style lang="stylus">
// @import '../../node_modules/vuetify/src/stylus/settings/_elevations.styl';
#appDrawer {
  overflow: hidden;

  .drawer-menu--scroll {
    height: calc(100vh - 64px);
    overflow: auto;
  }
}
</style>
